const checkAccess = (access) => {
  const user = JSON.parse(localStorage.getItem("jandle-admin"));
  let tempArray = [];
  user?.rolesAndAccess?.access?.forEach((acc) => {
    let type = acc.type;
    acc.permissions?.forEach((perm) => {
      tempArray?.push(`${perm.toLowerCase()}_${type.toLowerCase()}`);
    });
  });
  // console.log(tempArray, "tempArray")
  // let hasAccess = tempArray?.includes(access);
  let hasAccess =true;
  // console.log(hasAccess, "hasAccess")
  return hasAccess
};

export default checkAccess;
